import fetch from "libs/fetchWithAuth";
import { apiUrl } from 'libs/apiUrl';
const _baseUrl = apiUrl('/api/ext/files');

class Files {
	static save(data, req) {
		let _url = _baseUrl;
		let _method = 'POST';

		return fetch(_url, {
			method: _method,
			body: JSON.stringify(data),
		}, req);
	}

	static analyze(data, req) {
		return fetch(_baseUrl + '/analyze', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static assignMTEngines(data, req) {
		return fetch(_baseUrl + '/assign-mt-engines', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static assignAIModel(data, req) {
		return fetch(_baseUrl + '/assign-ai-model', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static assignMTEnginesMultiple(data, req) {
		return fetch(_baseUrl + '/assign-mt-engines-multiple', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static preTranslate(data, req) {
		return fetch(_baseUrl + '/pre-translate', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static createPreview(data, req) {
		return fetch(_baseUrl + '/create-preview', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static getPreviewHtml(projectID, fileID, targetLang, req) {
		return fetch(
			_baseUrl + `/get-translation-preview/${projectID}/${fileID}/${targetLang}`,
			{ method: 'GET' },
			req
		);
	}

	static prepareDownload(project, file, task, options, req) {
		return fetch(apiUrl('/api/ext/prepareDownloadTranslation'), {
			method: 'POST',
			body: JSON.stringify({
				project,
				file,
				task,
				options,
			}),
		}, req);
	}

	static prepareTrackChangesDownload(project, file, task, options, req) {
		return fetch(apiUrl('/api/ext/prepareDownloadTrackedChanges'), {
			method: 'POST',
			body: JSON.stringify({
				project,
				file,
				task,
				options,
			}),
		}, req);
	}

	static pseudoPreTranslate(data, req) {
		return fetch(_baseUrl + '/pseudo-pre-translate', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static prepareDownloadMultiple(data, req) {
		return fetch(
			apiUrl('/api/ext/prepareDownloadTranslationMultiple'),
			{
				method: 'POST',
				body: JSON.stringify(data),
			}, req
		);
	}

	static prepareXlfExport(data, req) {
		return fetch(`${_baseUrl}/export-xlf/prepare`, {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static prepareOriginalFilesDownload(data, req) {
		return fetch(`${_baseUrl}/original-files/prepare`, {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static prepareBilingualExport(data, req) {
		return fetch(`${_baseUrl}/export-bilingual/prepare`, {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static prepareTargetWithCommentsExport(data, req) {
		return fetch(`${_baseUrl}/export-target-with-comments/prepare`, {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}
}

export default Files;
